import { render } from "./feedbackTable.vue?vue&type=template&id=c5286202&scoped=true"
import script from "./feedbackTable.vue?vue&type=script&lang=js"
export * from "./feedbackTable.vue?vue&type=script&lang=js"

import "./feedbackTable.vue?vue&type=style&index=0&id=c5286202&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5286202"]])

export default __exports__